/**
 * Posts TanStack query key factory — keep in sync with posts.query-store usage.
 */
export const postsQueryKeys = {
  all: (gId?: string) => ['posts', gId] as const,
  single: (postId?: string, groupId?: string, locationId?: string) => ['posts', 'single', postId, groupId, locationId] as const,
  infinitePublicPosts: (gId?: string) => ['posts', gId, 'public', 'infinite'] as const,
  infiniteChannelPosts: (gId?: string, channelId?: string) => ['posts', gId, 'channel', channelId, 'infinite'] as const,
  infiniteChannelPinnedPosts: (gId?: string, channelId?: string) => ['posts', gId, 'channel', channelId, 'pinned', 'infinite'] as const,
  infiniteHomePinnedPosts: (gId?: string) => ['posts', gId, 'home-pinned', 'infinite'] as const,
  infiniteUserPosts: (gId?: string, contactId?: string) => ['posts', gId, 'user', contactId, 'infinite'] as const,
} as const

/**
 * Polls TanStack query key factory — keep in sync with polls.query-store usage.
 *
 * Poll-scoped keys live under the `'poll'` namespace (singular) so they can be
 * invalidated independently of the `'posts'` cache. The post-embedded
 * `poll` payload still rides along with `postsQueryKeys.*` and is patched in
 * place by the polls query store.
 */
export const pollsQueryKeys = {
  all: (pollId?: string) => ['poll', pollId] as const,
  voters: (pollId?: string, optionId?: string, groupId?: string, locationId?: string) =>
    ['poll', pollId, 'voters', optionId, groupId, locationId] as const,
} as const
